module.exports = __webpack_public_path__ + "img/SES_120410001.682d7777.jpg";